export const commons = {
  languages: {
    A1: 'A1 - Beginner',
    A2: 'A2 - Elementary',
    B1: 'B1 - Intermediate',
    B2: 'B2 - Upper Intermediate',
    C1: 'C1 - Advanced',
    C2: 'C2 - Proficient',
    Native: 'Native Language'
  },
  roles: {
    club: 'Club',
    artist: 'Artist',
    admin: 'Admin'
  },
  artistJobs: {
    Hostess: 'Hostess',
    GoGo: 'GoGo',
    Strip: 'Strip'
  },
  schedule: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday'
  },
  paymentFrequency: {
    Daily: 'Day',
    Weekly: 'Week',
    Monthly: 'Month'
  },
  flightPaymentType: {
    Club: 'Paid by club',
    Artist: 'Paid by artist',
    Credit: 'Ticket credit',
    Agreement: 'By agreement',
    Compensation: 'Compensation'
  },
  artistConsumation: {
    label: 'Consumation',
    Active: 'Active',
    Passive: 'Passive'
  },
  workItemType: {
    Request: 'Requests',
    Invite: 'Invitation'
  },
  workItemStatus: {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    Withdrawn: 'Withdrawn',
    Expired: 'Expired',
    ContractOngoing: 'Contract in effect',
    ContractRequestedEndDate: 'Contract end date requested',
    FinishingContract: 'Contract ending',
    ContractCompleted: 'Contract completed',
    ClubSetEndDate: 'Club set end date',
    Cancelled: 'Cancelled'
  },
  artistStatuses: {
    LookingForWork: 'Looking for work',
    OnContract: 'Under contract',
    FinishingContract: 'Finishing contract',
    OnVacation: 'On vacation',
    HiddenFromSearch: 'Hidden from search'
  },
  loading: {
    generic: 'Loading data...',
    requests: 'Loading requests...',
    invites: 'Loading invitations...'
  },
  flightCompensationOptions: {
    oneMonth: 'For 1 month of contract',
    twoMonths: 'For 2 months of contract',
    threeMonths: 'For 3 months of contract',
    sixMonths: 'For 6 months of contract, the club buys a return ticket',
    backTicket: 'Return ticket'
  },
  transportFromAirport: {
    label: 'Transport from the airport/station',
    options: {
      clubOrganizes: 'Organized by the club',
      artistSelf: 'Artist arranges own transport'
    }
  },
  notFound: {
    generic: 'The list is empty.',
    requests: 'There are no requests yet.',
    invites: 'There are no invitations yet.',
    artists: 'Currently, the artist list is empty',
    search:
      'We did not find a club matching your search. Please report this to our support so we can improve the search.'
  },
  artistParametres: {
    weight: 'Weight',
    height: 'Height',
    body: 'Body',
    chest: 'Chest',
    waist: 'Waist',
    hips: 'Hips'
  },
  dressCodeOptions: {
    strip: 'Strips',
    underwear: 'Underwear',
    longDress: 'Long dress',
    body: 'Bodysuit',
    shortDress: 'Short dress'
  },
  'follow-us-in-social': 'Follow us on social media:',
  continue: 'Continue',
  'continue-with-google': 'Continue with Google',
  artistHiringIsOpen: 'Artist recruitment is open',
  artistHiringIsClosed: 'Artist recruitment is closed',
  acceptWithExperience: 'Accepting without experience',
  dontAcceptWithoutExperience: 'Not accepting without experience',
  copyLink: 'Copy link',
  withExperience: 'With experience',
  withouthExperience: 'Without experience',
  agree: 'I agree to the terms',
  change: 'Change',
  add: 'Add',
  citizenship: 'Citizenship',
  save: 'Save',
  'save-and-continue': 'Save and continue',
  edit: 'Edit',
  portfolio: 'Portfolio',
  close: 'Close',
  closed: 'Closed',
  finish: 'Finish',
  help: 'Help',
  logout: 'Logout',
  country: 'Country',
  place: 'Location',
  deleteAccount: 'Delete account',
  changePassword: 'Change password',
  hide: 'Hide',
  selectCountry: 'Select country',
  delete: 'Delete',
  exit: 'Yes, I want to log out',
  'undo-to-account': 'Back to account',
  location: 'Location',
  language: 'Languages',
  parametres: 'Parameters',
  about: 'About',
  my: 'My',
  photo: 'Photos',
  video: 'Videos',
  experience: 'Experience',
  galery: 'Gallery',
  write: 'Write',
  yes: 'Yes',
  step: 'Step',
  no: 'No',
  or: 'Or',
  resend: 'Resend',
  open: 'open',
  cancel: 'Cancel',
  need: 'Needed',
  dontNeed: 'Not needed',
  endWork: 'End of work',
  startDate: 'Work start date',
  endDate: 'Work end date',
  vacancy: 'Vacancy',
  creditation: 'Ticket credit',
  aroundTheClock: '24/7',
  flightTickets: 'Flight tickets',
  ticketCreditation: 'Ticket credit',
  crazyMenu: 'Crazy menu',
  tea: 'Tips',
  show: 'Show',
  deposit: 'Deposit',
  guarantee: 'Guarantee',
  rate: 'Rate',
  clubFee: 'Club fee',
  separated: 'Separate',
  forShift: 'Per shift',
  required: 'Required',
  optional: 'Optional',
  quantity: 'Quantity',
  choreographerInClub: 'Choreographer available in club',
  photoshootParticipation: 'Participation in photoshoots',
  artistsInShift: 'Artists per shift',
  scenes: 'Scenes',
  dynamicPole: 'Dynamic pole',
  staticPole: 'Static pole',
  artistTraining: 'Artist training',
  teching: 'Training',
  dressCodeForArtists: 'Dress code for artists',
  dressCode: 'Dress code',
  rentPayment: 'Rent payment',
  utilitiesPayment: 'Utility payments',
  clubProvidedAccommodation: 'Club provided accommodation',
  housingPhoto: 'Housing photo',
  noteEditLater: 'You can make changes later',
  paydByArtist: 'Paid by artist',
  paydByClub: 'Paid by club',
  peopleInRoom: 'People in room up to',
  uploadFromDevice: 'Upload from device',
  selectMainPhoto: 'Select main photo',
  videoParams:
    'Video size must not exceed {size} MB, supported formats: MP4, QuickTime,',
  photoParams: 'Photo size must not exceed {size} MB',
  photoParamsHousing: 'Photo size must not exceed 5 MB, Max photo count 5',
  general: 'General',
  payments: 'Payments',
  full: 'Full',
  topless: 'Topless',
  gogo: 'GoGo',
  crazymenu: 'Crazy menu',
  continueFilling: 'Continue filling out',
  search: 'Search',
  other: 'Other',
  foreignLanguages: 'Foreign languages',
  dancer: 'Dancer',
  untilNow: 'Until now',
  invite: 'Invite',
  cancelInvite: 'Cancel invitation',
  dateFormatPlaceholder: 'dd.mm.yy',
  askArtist: 'Ask the artist a question',
  askClub: 'Ask the club a question',
  reject: 'Reject',
  accept: 'Accept',
  confirm: 'Confirm',
  iConfirm: 'I confirm',
  workAt: 'Working since',
  setLastDate: 'Set the last date',
  lastWorkDay: 'Last work day',
  cancelArrangement: 'Cancel arrangement',
  back: 'Back',
  wantedVacancy: 'Desired vacancies',
  addClub: 'Add club',
  goToInvitation: 'Go to invitation',
  goToRequest: 'Go to request',
  vacancyConsider: 'Which vacancies are you considering?',
  super: 'Super',
  withouthExprience: 'Withouth Experience',
  uploadManyFromDevice: 'Upload multiple photos from your device',
  clubLocation: 'Club location',
  specify: 'Specify',
  housing: 'Housing',
  position: 'Position',
  guest: 'Guest',
  workingHours: 'Working hours',
  isPaydByClub: 'Paid by club',
  isntPaydByClub: 'Not paid by club',
  utilityPayments: 'Utility payments',
  payment: 'Payment',
  request: 'Request',
  penalties: 'Penalties',
  aboutClub: 'About the club',
  sendRequest: 'Send request',
  cancelRequest: 'Cancel request',
  profile: 'Profile',
  chat: 'Chat',
  housigInClubApartsRequired: 'Club provided accommodation is required'
};
